import type { IMapSurface } from '../MapSurface';

export interface MapMarkerMetricsMeters {
    categoryCubeSize: number;
    gorgeCubeSize: number;
    decisionSignSize: number;
    decisionPoleHeight: number;
    iconSignSize: number;
    iconPoleHeight: number;
    categoryPoleHeight: number;
    categoryClusterRadius: number;
    stackGapFactor: number;
}

export type MapMarkerMetricsWorld = MapMarkerMetricsMeters;

/** Physical design tokens. Both renderers convert these metres into scene units. */
export const DEFAULT_MAP_MARKER_METRICS_METERS: Readonly<MapMarkerMetricsMeters> = Object.freeze({
    categoryCubeSize: 24.4104,
    gorgeCubeSize: 18.3078,
    decisionSignSize: 38.6498,
    decisionPoleHeight: 43.7353,
    iconSignSize: 31.5301,
    iconPoleHeight: 36.6156,
    /* 2026-08-16 Alex (Screenshot 119657): "Die Wuerfel koennen ruhig ein
     * bisschen weiter oben in der Luft stehen" — von 52.9 m angehoben. */
    categoryPoleHeight: 85,
    categoryClusterRadius: 32.5,
    stackGapFactor: 1.12,
});

export function resolveMapMarkerMetrics(
    surface: IMapSurface,
    overrides: Partial<MapMarkerMetricsMeters> = {},
): MapMarkerMetricsWorld {
    const metres = { ...DEFAULT_MAP_MARKER_METRICS_METERS, ...overrides };
    const scale = surface.worldUnitsPerMeter;
    return {
        categoryCubeSize: metres.categoryCubeSize * scale,
        gorgeCubeSize: metres.gorgeCubeSize * scale,
        decisionSignSize: metres.decisionSignSize * scale,
        decisionPoleHeight: metres.decisionPoleHeight * scale,
        iconSignSize: metres.iconSignSize * scale,
        iconPoleHeight: metres.iconPoleHeight * scale,
        categoryPoleHeight: metres.categoryPoleHeight * scale,
        categoryClusterRadius: metres.categoryClusterRadius * scale,
        stackGapFactor: metres.stackGapFactor,
    };
}
